/**
 * API 错误码映射配置
 * 错误码与多语言 key 的映射关系
 */

/**
 * 错误码映射表
 * @type {Record<number, string>}
 */
export const ERROR_CODE_MAP = {
  10001: 'errorCodes.server_error',
  10002: 'errorCodes.param_empty',
  10003: 'errorCodes.unauthorized',
  10004: 'errorCodes.user_not_registered',
  10005: 'errorCodes.user_exists',
  10006: 'errorCodes.user_disabled',
  10007: 'errorCodes.forbidden',
  10008: 'errorCodes.user_quota_insufficient',
  10009: 'errorCodes.data_not_found',
  10010: 'errorCodes.data_exists',
  10011: 'errorCodes.name_exists',
  10012: 'errorCodes.project_id_empty',
  10013: 'errorCodes.project_not_found',
  10014: 'errorCodes.task_type_empty',
  10015: 'errorCodes.project_file_name_empty',
  10016: 'errorCodes.insufficient_space',
  10017: 'errorCodes.task_id_empty',
  10018: 'errorCodes.task_not_found',
  10019: 'errorCodes.task_name_empty',
  10020: 'errorCodes.task_template_not_found',
  10021: 'errorCodes.task_processing',
  10022: 'errorCodes.status_empty',
  10023: 'errorCodes.size_empty',
  10024: 'errorCodes.algorithm_id_empty',
  10025: 'errorCodes.input_param_empty',
  10026: 'errorCodes.project_data_empty',
  10027: 'errorCodes.file_upload_failed',
  10028: 'errorCodes.file_size_empty',
  10029: 'errorCodes.user_has_org',
  10030: 'errorCodes.billing_cycle_not_found',
  10031: 'errorCodes.parent_node_id_empty',
  10032: 'errorCodes.share_not_found',
  10033: 'errorCodes.share_expired',
  10034: 'errorCodes.share_requires_password',
  10035: 'errorCodes.share_password_incorrect',
  10036: 'errorCodes.user_not_found',
  10037: 'errorCodes.username_exists',
  10038: 'errorCodes.login_failed',
  10039: 'errorCodes.email_exists',
  10040: 'errorCodes.reg_email_sent',
  10041: 'errorCodes.password_incorrect',
}

/**
 * 已知的错误码集合（用于快速查找）
 * @type {Set<number>}
 */
export const KNOWN_ERROR_CODES = new Set(Object.keys(ERROR_CODE_MAP).map(Number))
